import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";

import Page from "@/components/Page";
import Loading from "@/components/Loading";
import Breadcrumbs from "@/components/Breadcrumbs";
import MainActions from "@/components/MainActions";
import VLFCard from "@/components/Card";
import DataTable from "@/components/DataTable";

import {UserRoleAPI} from "@/api/user_role";

import AddIcon from "@mui/icons-material/Add";

import {ERROR_OPERATION} from "@/utils/constants";

// Cosa fa ciascun ruolo di sistema (gli altri mostrano la descrizione salvata)
const ROLE_HINTS = {
	Admin: "Vede e modifica tutto",
	SuperUser: "Vede e modifica tutto",
	Staff: "Vede le aree indicate nei permessi del ruolo",
	Player: "Vede solo i propri dati",
};

function UserRolesPage(props) {
	const {handleNotification} = props;
	const navigate = useNavigate();

	const [loading, setLoading] = useState(true);
	const [userRoles, setUserRoles] = useState([]);

	useEffect(() => {
		const getUserRoles = async () => {
			setLoading(true);
			try {
				setUserRoles((await UserRoleAPI.list()) || []);
			} catch {
				handleNotification(ERROR_OPERATION, "error");
			} finally {
				setLoading(false);
			}
		};
		getUserRoles();
	}, []);

	return (
		<Page>
			<Loading visible={loading} />
			<Breadcrumbs
				current="Ruoli e permessi"
				actions={
					<MainActions
						actions={[
							{
								icon: <AddIcon />,
								title: "Nuovo ruolo",
								onClick: () => navigate("/settings/user-roles/new"),
							},
						]}
					/>
				}
			/>
			<VLFCard
				content={
					<DataTable
						columns={[
							{key: "name", label: "Ruolo", sortable: true},
							{
								key: "description",
								label: "Cosa vede",
								render: (r) => ROLE_HINTS[r.name] || r.description || "—",
							},
						]}
						rows={userRoles.map((r) => ({...r, id: r.id || r.name}))}
						onRowClick={(r) => navigate("/settings/user-roles/" + r.name)}
						empty="Nessun ruolo."
					/>
				}
			/>
		</Page>
	);
}

export default UserRolesPage;
